import {
  GET_LEAK_DETECTORS_LIST_IN_PROGRESS,
  GET_LEAK_DETECTORS_LIST_SUCCESS,
  GET_LEAK_DETECTORS_LIST_FAIL,
} from "../constants";
import { LOGOUT } from "../../authentication/constants";

const initialState = {
  list: [],
  inProgress: false,
  error: false,
};

/**
 * Leak detectors reducer
 *
 * @param {Object} state
 * @param {Object} action
 *
 * @return {Object}
 */
export default function leakDetectors(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case GET_LEAK_DETECTORS_LIST_IN_PROGRESS:
      return {
        ...state,
        inProgress: true,
        error: false,
      };

    case GET_LEAK_DETECTORS_LIST_SUCCESS:
      return {
        ...state,
        list: payload.list,
        inProgress: false,
      };

    case GET_LEAK_DETECTORS_LIST_FAIL:
      return {
        ...state,
        inProgress: false,
        error: true,
      };

    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };

    default:
      return state;
  }
}
